import React, { useEffect, useState } from "react";
import { getPermits } from "../../api/permit";
import { useNavigate, useParams } from "react-router-dom";
import { formatDate } from "../../utils/date";

export default function PermitMilestones() {
  const [permits, setPermits] = useState([]);
  const navigate = useNavigate();
  const { id: projectId } = useParams();

  useEffect(() => {
    (async () => {
      const data = await getPermits({
        page: 1,
        page_size: 9999,
        ordering: "planned_date",
      });
      const all = data.results || data;
      setPermits(all);
    })();
  }, []);

  const statusColor = (status) => {
    switch (status) {
      case "completed":
        return "bg-green-500";
      case "delayed":
        return "bg-red-500";
      case "planned":
        return "bg-yellow-500";
      case "in_progress":
        return "bg-blue-600";
      default:
        return "bg-gray-400";
    }
  };

  const statusText = (status) => {
    switch (status) {
      case "completed":
        return "완료";
      case "delayed":
        return "지연";
      case "planned":
        return "계획";
      case "in_progress":
        return "진행중";
      default:
        return "알수없음";
    }
  };

  const grouped = permits.reduce((acc, p) => {
    const date = p.planned_date ? formatDate(p.planned_date) : "-";
    if (!acc[date]) acc[date] = [];
    acc[date].push(p);
    return acc;
  }, {});

  const dates = Object.keys(grouped).sort();

  return (
    <div className="mobile-page-root mb-16">
      <div className="mobile-page-root-inner space-y-3">
        {/* 헤더 */}
        <div className="bg-white rounded-lg p-3 border min-w-0">
          <h2 className="text-lg font-bold text-gray-900">인허가 마일스톤</h2>
          <p className="text-xs text-gray-500 mt-0.5">
            {permits.length}건의 인허가 일정
          </p>
        </div>

        {/* 타임라인 */}
        <div className="bg-white rounded-lg p-3 border min-w-0">
          <div className="flex flex-col gap-3">
            {dates.map((date, idx) => {
              const isLast = idx === dates.length - 1;
              return (
                <React.Fragment key={date}>
                  <div className="flex flex-col gap-2 rounded-lg border border-gray-200 p-3 bg-gray-50 shadow-sm">
                    <div className="flex items-center gap-2">
                      <span className="w-3 h-3 rounded-full bg-blue-500 border border-white shadow-sm" />
                      <p className="text-sm font-semibold text-gray-800">
                        {date}
                      </p>
                    </div>

                    <div className="space-y-2">
                      {grouped[date].map((p) => (
                        <div
                          key={p.id}
                          onClick={() =>
                            navigate(
                              `/project/${projectId}/permit/view/${p.id}`
                            )
                          }
                          className="p-2 bg-white hover:bg-gray-50 border border-gray-200 rounded-lg text-xs cursor-pointer transition-colors active:scale-95"
                        >
                          <div className="flex items-center gap-1.5">
                            <span
                              className={`w-2 h-2 rounded-full flex-shrink-0 ${statusColor(
                                p.status
                              )}`}
                            />
                            <span className="truncate font-medium text-gray-900">
                              {p.name}
                            </span>
                          </div>
                          <div className="text-xs text-gray-600 text-center mt-1 bg-gray-50 rounded px-1.5 py-0.5 border border-gray-200 inline-block">
                            {statusText(p.status)}
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>

                  {!isLast && (
                    <div
                      className="flex flex-col items-center justify-center gap-1"
                      aria-hidden="true"
                    >
                      <div className="w-px h-4 bg-gradient-to-b from-blue-200 to-blue-300" />
                      <div className="w-9 h-9 rounded-full bg-blue-50 border border-blue-200 flex items-center justify-center shadow-sm text-blue-600 text-lg leading-none">
                        ↓
                      </div>
                      <div className="w-px h-4 bg-gradient-to-b from-blue-300 to-transparent" />
                    </div>
                  )}
                </React.Fragment>
              );
            })}
          </div>
        </div>

        {/* 안내 메시지 */}
        <div className="bg-blue-50 rounded-lg p-3 border border-blue-100 min-w-0">
          <p className="text-xs text-blue-700 text-center">
            💡 날짜별 카드 리스트로 세로 배치되어 모바일에서 한눈에 볼 수
            있어요.
          </p>
        </div>
      </div>
    </div>
  );
}
